import { render, staticRenderFns } from "./NewsArticle.vue?vue&type=template&id=ee1ca3c4&scoped=true&"
import script from "./NewsArticle.vue?vue&type=script&lang=ts&"
export * from "./NewsArticle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1ca3c4",
  null
  
)

export default component.exports